import { useTranslation } from 'react-i18next'

import { Header } from '../components/Header'
import { HeaderMobile } from '../components/HeaderMobile'
import { PricingPlans } from '../components/PricingPlans'

export const Pricing = () => {
  const { t } = useTranslation()

  return (
    <div>
      <div className="block sm:hidden">
        <HeaderMobile />
      </div>
      <div className="hidden sm:block">
        <Header />
      </div>

      <div
        className="flex flex-col overflow-auto px-6 py-8 sm:top-0"
        style={{ height: 'calc(100vh - 89px)' }}
      >
        <h1 className="mb-3 text-center text-5xl font-medium">
          {t('pricing')}
        </h1>
        <p className="mb-5 text-center text-2xl">{t('saveAnnual')}</p>
        <PricingPlans />
      </div>
    </div>
  )
}
